import React, { useState, useCallback, useEffect } from "react";
import cn from "classnames";
import Calendar from "shared/Calendar";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import ChargerTable from "../components/reportComponent/reportChargerTable";
import ReportTab from "components/reportComponent/ReportTab";
import CustomDropDown from "./CustomDropDown";
import styles from "./reports.module.scss";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getUpandDownEnergyReports,
  getUpandDownEnergyReportsDownload,
} from "redux/actions/reports";
import { getChargerAndEvseAsync } from "redux/siteSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import moment from "moment";
let maxDate = new Date(),
  minDate = new Date(process.env.REACT_APP_REPORTS_MIN_DATE),
  todayCurrentDate = new Date(),
  unitsSystem = process.env.REACT_APP_UNITS_SYSTEM;

export default function Report(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  if (splitLocation[1] !== "myChargers" || splitLocation[1] !== "myFleet") {
    localStorage.removeItem("shortingBy");
    localStorage.removeItem("fleetShorting");
    localStorage.removeItem("checkedId");
    localStorage.removeItem("selectedId");
  }
  let date = new Date();
  const [siteMultiSelect, setSiteMultiSelect] = useState([]);
  const [selectedSiteList, selectedSiteItem] = useState();
  const [selectedDate, setSelectedSate] = useState();
  const [selecteData, setSelecteData] = useState(false);
  const [data, setData] = useState([]);
  const [outerSideClick, setOuterSideClick] = useState(true);
  const [outerSideClick1, setOuterSideClick1] = useState(true);
  const [energyUp, setEnergyUp] = useState({ label: [], value: [] });
  const [energyDown, setEnergyDown] = useState({ label: [], value: [] });
  const [evseArray, setEvseArray] = useState([]);
  const [evseSites, setEvseSitesArray] = useState([]);
  const [selectDate, setSelectDate] = useState(date);

  const [selectMonthYear, setSelectMonthYear] = useState(date);

  const [selectYear, setSelectYear] = useState(date);
  const [selectedEvse, setSelectedEvse] = useState("");

  const [typeMode, setType] = useState("Day");
  const [xAxisName, setxAxisName] = useState("Day");

  const setTypeMode = (value) => {
    setType(value);
  };
  const selectAtleastOneCharger = () => {
    if (selectedEvse.length == 0) {
      alert("Please select atleast one charger from charger list");
    }
  };

  const setTypeModeAndFetchRecord = (val) => {
    selectAtleastOneCharger();
    setTypeMode(val);
    fetchReports(selectedEvse, val, selectDate, selectMonthYear, selectYear);
  };

  const setDateAndFetchRecords = (date, typeM) => {
    selectAtleastOneCharger();
    if (typeM == "Day") {
      setSelectDate(date);
      fetchReports(selectedEvse, typeMode, date, selectMonthYear, selectYear);
    } else if (typeM == "Month") {
      setSelectMonthYear(date);
      fetchReports(selectedEvse, typeMode, selectDate, date, selectYear);
    } else if (typeM == "Year") {
      setSelectYear(date);
      fetchReports(selectedEvse, typeMode, selectDate, selectMonthYear, date);
    }
  };

  // const getMonthValue = () => {
  //   const month = monthYear && monthYear.month ? monthYear.month : 0;
  //   const year = monthYear && monthYear.year ? monthYear.year : 0;

  //   return month && year ? `${month}-${year}` : "Select Month";
  // };

  const [startDateInYear, setStartDateInYear] = useState(new Date());

  const filterData = useCallback((data) => {
    selectedSiteItem(data);
    console.log("selectedSiteListselectedSiteList", data);
  }, []);

  // const selectDate = useCallback((data) => {
  //   setSelectedSate(data);
  // }, []);

  // const dataSelect = async (data) => {
  //   // return data;
  //   setSelecteData(data)
  // }

  // if(localStorage.getItem('checka')===true){
  //   console.log('recieved report check')
  //   // localStorage.removeItem("checka");
  // }
  // else{
  //   console.log('not recieved')
  // }
  // console.log('bb',localStorage.getItem('checkb'))

  window.addEventListener("click", function (e) {
    if (
      e &&
      e.target &&
      document.getElementById("reportClickbox")?.contains(e.target)
    ) {
      setOuterSideClick(true);
    } else {
      setOuterSideClick(false);
    }
  });

  useEffect(() => {
    FetchChangerAndSite();
  }, []);

  const FetchChangerAndSite = () => {
    dispatch(
      getChargerAndEvseAsync((evse) => {
        setEvseArray(evse.siteEvse);
        setSitesArrayFromEvseList(evse.siteEvse);
        // fetchReports(evse.siteEvse);
      })
    );
  };

  const setSitesArrayFromEvseList = (siteEvse) => {
    let multisiteArray = [
      // { value: 0, label: "Select All" }
    ];
    siteEvse.map((evseD) => {
      if (!multisiteArray.find((e) => e.value === evseD.site.siteId)) {
        multisiteArray.push({
          label: evseD.site.name,
          value: evseD.site.siteId,
        });
      }
    });
    setSiteMultiSelect(multisiteArray);
  };

  const filterEvseId = (evseData) => {
    let evseIds = "";
    if (evseData && evseData.length > 0) {
      evseData.map((item, index) => {
        if (index !== 0) {
          // if (index !== evseData.length - 1) {
          evseIds = evseIds + ",";
          // }
        }
        // evseIds = evseIds + item.evseId;
        evseIds = evseIds + item;
      });
    }
    console.log("evseIdsevseIdsevseIds", evseIds);
    return evseIds;
  };

  const getSelectEvseIds = (evseData) => {
    setSelectedEvse(evseData);
    fetchReports(evseData, typeMode, selectDate, selectMonthYear, selectYear);
  };

  let checkDateIsGreaterThanTodayDate = (y, m) => {
    let newDate = moment(y + "-" + m + "-" + "01", "YYYY-MM-DD").endOf("month"),
      todayDate = moment(new Date());
    return newDate > todayDate ? true : false;
  };

  var lastdayFromMonthandYear = function (y, m) {
    return moment(y + "-" + m + "-" + "01", "YYYY-MM-DD")
      .endOf("month")
      .format("D");
  };

  const fetchReports = async (
    evseData,
    mode,
    selectDateD,
    selectMonthYearD,
    selectYearD
  ) => {
    if (evseData.length == 0) {
      setEnergyUp({ label: [], value: [] });
      setEnergyDown({
        label: [],
        value: [],
      });
      return;
    }
    const evseIds = filterEvseId(evseData);
    let startTimeStamp, endTimeStamp, granularity;
    if (mode == "Day") {
      let selectedDay = moment(selectDateD).format("YYYY-MM-DD");
      startTimeStamp = selectedDay;
      endTimeStamp = selectedDay;
      granularity = unitsSystem === "metric" ? "YYYY-MM-dd" : "YYYY-MM-DD";
      endTimeStamp = endTimeStamp + "T23:59:59Z";
    } else if (mode == "Month") {
      let MonthValue = selectMonthYearD.getMonth() + 1;
      if (MonthValue < 10) {
        MonthValue = "0" + MonthValue;
      }
      let YearValue = selectMonthYearD.getFullYear();

      // let splittedMonthYear = selectMonthYear.split("/");
      startTimeStamp = YearValue + "-" + MonthValue + "-" + "01";
      endTimeStamp = checkDateIsGreaterThanTodayDate(YearValue, MonthValue)
        ? todayCurrentDate.toISOString()
        : YearValue +
          "-" +
          MonthValue +
          "-" +
          lastdayFromMonthandYear(YearValue, MonthValue) +
          "T23:59:59Z";
      granularity = unitsSystem === "metric" ? "YYYY-MM-dd" : "YYYY-MM-DD";
    } else if (mode == "Year") {
      let YearValue = selectYearD.getFullYear();

      startTimeStamp = YearValue + "-01-01";
      endTimeStamp =
        todayCurrentDate.getFullYear() === YearValue
          ? todayCurrentDate.toISOString()
          : YearValue + "-12-31T23:59:59Z";

      granularity = "YYYY-MM";
    } else if (mode == "lifeTime") {
      startTimeStamp = "2022-01-01";
      endTimeStamp = todayCurrentDate.toISOString();
      granularity = "YYYY";
    }
    startTimeStamp = startTimeStamp + "T00:00:00Z";

    dispatch(
      getUpandDownEnergyReports(
        evseIds,
        startTimeStamp,
        endTimeStamp,
        granularity,
        (elements) => {
          if (mode === "Day") {
            setxAxisName("Day");
          } else if (mode === "Month") {
            setxAxisName("Days");
          } else if (mode === "Year") {
            setxAxisName("Months");
          } else if (mode === "lifeTime") {
            setxAxisName("Years");
          }
          segregateEnergyUpAndDown(elements, mode, selectMonthYearD);
        }
      )
    );
  };

  const downloadReports = async () => {
    const evseIds = filterEvseId(selectedEvse);

    let startTimeStamp, endTimeStamp, granularity;
    if (typeMode == "Day") {
      let selectedDay = moment(selectDate).format("YYYY-MM-DD");
      startTimeStamp = selectedDay;
      endTimeStamp = selectedDay;
      granularity = unitsSystem === "metric" ? "YYYY-MM-dd" : "YYYY-MM-DD";
      endTimeStamp = endTimeStamp + "T23:59:59Z";
    } else if (typeMode == "Month") {
      let MonthValue = selectMonthYear.getMonth() + 1;
      if (MonthValue < 10) {
        MonthValue = "0" + MonthValue;
      }
      let YearValue = selectMonthYear.getFullYear();

      // let splittedMonthYear = selectMonthYear.split("/");
      startTimeStamp = YearValue + "-" + MonthValue + "-" + "01";
      endTimeStamp = checkDateIsGreaterThanTodayDate(YearValue, MonthValue)
        ? todayCurrentDate.toISOString()
        : YearValue +
          "-" +
          MonthValue +
          "-" +
          lastdayFromMonthandYear(YearValue, MonthValue) +
          "T23:59:59Z";
      granularity = unitsSystem === "metric" ? "YYYY-MM-dd" : "YYYY-MM-DD";
    } else if (typeMode == "Year") {
      let YearValue = selectYear.getFullYear();

      startTimeStamp = YearValue + "-01-01";
      endTimeStamp =
        todayCurrentDate.getFullYear() === YearValue
          ? todayCurrentDate.toISOString()
          : YearValue + "-12-31T23:59:59Z";

      granularity = "YYYY-MM";
    } else if (typeMode == "lifeTime") {
      startTimeStamp = "2022-01-01";
      endTimeStamp = todayCurrentDate.toISOString();
      granularity = "YYYY";
    }
    startTimeStamp = startTimeStamp + "T00:00:00Z";

    console.log(
      "testsecond",
      evseIds,
      startTimeStamp,
      endTimeStamp,
      granularity
    );

    dispatch(
      getUpandDownEnergyReportsDownload(
        evseIds,
        startTimeStamp,
        endTimeStamp,
        granularity
      )
    );
  };

  const segregateEnergyUpAndDown = (elements, mode, selectMonthYearD) => {
    let energyUpLabelArray = [],
      energyDownLabelArray = [],
      energyUpValueArray = [],
      energyDownValueArray = [];
    elements.map((item) => {
      item.values.map((subItem) => {
        const { energyDown, energyUp, time } = subItem;
        let xAxisData = time;

        if (mode === "Month") {
          // xAxisData = new Date(time).getDate();
          xAxisData = moment(time, "YYYY-MM-DD").date();
        }
        if (mode === "Year") {
          xAxisData = moment(time, "YYYY-MM").format("MM");
        }

        if (subItem.hasOwnProperty("energyDown")) {
          energyDownLabelArray.push(xAxisData);
          energyDownValueArray.push(
            unitsSystem === "metric" ? Math.abs(energyDown) : energyDown / 1000
          );
        } else if (subItem.hasOwnProperty("energyUp")) {
          energyUpLabelArray.push(xAxisData);
          energyUpValueArray.push(
            unitsSystem === "metric" ? Math.abs(energyUp) : energyUp / 1000
          );
        }
      });
    });
    // Show Full months days (30or 31 day slots) when month selected month is lesser than current month
    // If  month selected is the current one .Then it should show days equal to current date
    if (mode === "Month") {
      let MonthValue = selectMonthYearD.getMonth() + 1;
      if (MonthValue < 10) {
        MonthValue = "0" + MonthValue;
      }
      let YearValue = selectMonthYearD.getFullYear();
      let numberofDaysInAMonth;
      if (checkDateIsGreaterThanTodayDate(YearValue, MonthValue)) {
        numberofDaysInAMonth = todayCurrentDate.getDate();
      } else {
        numberofDaysInAMonth = lastdayFromMonthandYear(YearValue, MonthValue);
      }

      let energyUpLabelArrayCopy = [],
        energyUpValueArrayCopy = [],
        energyDownLabelArrayCopy = [],
        energyDownValueArrayCopy = [];
      for (let i = 1; i <= numberofDaysInAMonth; i++) {
        let findMissingUpIndex = energyUpLabelArray.findIndex(
          (item) => item === i
        );
        if (findMissingUpIndex !== -1) {
          energyUpLabelArrayCopy.push(energyUpLabelArray[findMissingUpIndex]);
          energyUpValueArrayCopy.push(energyUpValueArray[findMissingUpIndex]);
        } else {
          energyUpLabelArrayCopy.push(i);
          energyUpValueArrayCopy.push(0);
        }
        let findMissingDownIndex = energyDownLabelArray.findIndex(
          (item) => item === i
        );
        if (findMissingDownIndex !== -1) {
          energyDownLabelArrayCopy.push(
            energyDownLabelArray[findMissingDownIndex]
          );
          energyDownValueArrayCopy.push(
            energyDownValueArray[findMissingDownIndex]
          );
        } else {
          energyDownLabelArrayCopy.push(i);
          energyDownValueArrayCopy.push(0);
        }
      }
      energyUpLabelArray = energyUpLabelArrayCopy;
      energyUpValueArray = energyUpValueArrayCopy;
      energyDownLabelArray = energyDownLabelArrayCopy;
      energyDownValueArray = energyDownValueArrayCopy;
    } else if (mode === "Year") {
      let energyUpLabelArrayCopy = [],
        energyUpValueArrayCopy = [],
        energyDownLabelArrayCopy = [],
        energyDownValueArrayCopy = [],
        numberOdMonths = 12;
      if (selectYear.getFullYear() === todayCurrentDate.getFullYear()) {
        numberOdMonths = todayCurrentDate.getMonth() + 1;
      }

      [...Array(numberOdMonths)].map((m, i) => {
        const monthValue = i < 9 ? "0" + (i + 1) : String(i + 1),
          month = moment(monthValue, "MM").format("MMMM");

        let findMissingUpIndex = energyUpLabelArray.findIndex(
          (dataRecord) => dataRecord == monthValue
        );

        if (findMissingUpIndex !== -1) {
          energyUpLabelArrayCopy.push(
            moment(energyUpLabelArray[findMissingUpIndex], "MM").format("MMMM")
          );
          energyUpValueArrayCopy.push(energyUpValueArray[findMissingUpIndex]);
        } else {
          energyUpLabelArrayCopy.push(month);
          energyUpValueArrayCopy.push(0);
        }

        let findMissingDownIndex = energyDownLabelArray.findIndex(
          (item) => item == monthValue
        );
        if (findMissingDownIndex !== -1) {
          energyDownLabelArrayCopy.push(
            moment(energyDownLabelArray[findMissingDownIndex], "MM").format(
              "MMMM"
            )
          );
          energyDownValueArrayCopy.push(
            energyDownValueArray[findMissingDownIndex]
          );
        } else {
          energyDownLabelArrayCopy.push(month);
          energyDownValueArrayCopy.push(0);
        }
      });
      energyUpLabelArray = energyUpLabelArrayCopy;
      energyUpValueArray = energyUpValueArrayCopy;
      energyDownLabelArray = energyDownLabelArrayCopy;
      energyDownValueArray = energyDownValueArrayCopy;
    }
    setEnergyUp({ label: energyUpLabelArray, value: energyUpValueArray });
    setEnergyDown({
      label: energyDownLabelArray,
      value: energyDownValueArray,
    });
    console.log("759840759840759840", energyUp, energyDown);
  };
  return (
    <div className={cn("Report", styles.block, styles.block_layout)}>
      <div className={cn(styles.flex, styles.flex_layout)}>
        <Header page_name="My Reports"></Header>

        <div className={cn(styles.block5, styles.block5_layout)}>
          <div className={cn(styles.block5_item)}>
            <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
              {"Select Site"}
            </h3>
          </div>
          <div className={cn(styles.block5_spacer)} />
          <div id="reportClickbox" className={cn(styles.block5_item1)}>
            <CustomDropDown
              reportClickCheck={outerSideClick}
              dropdownData={siteMultiSelect}
              chargerCallback={filterData}
            />
            {/* </div> */}
          </div>
          <div className={cn(styles.block5_spacer1)} />
          <div className={cn(styles.block5_item2)}>
            <div
              className={cn(styles.block6, styles.block6_layout)}
              onClick={() => {
                downloadReports();
              }}
            >
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights1)}>
                  {"Generate Reports"}
                </pre>
              </h5>
            </div>
          </div>
        </div>

        <div className={cn(styles.block9, styles.block9_layout)}>
          <div className={cn(styles.block9_item)}>
            <h3 className={cn(styles.subtitle, styles.subtitle_layout1)}>
              {"View as:"}
            </h3>
          </div>
          <div className={cn(styles.block9_spacer)} />
          <div className={cn(styles.block9_item1)}>
            <div className={cn(styles.block10, styles.block10_layout)}>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <div className={cn(styles.flex3_item)}>
                  {/* <div className={cn(styles.box13, styles.box13_layout)}> */}
                  <div className={cn(styles.subtitle, styles.subtitle_layout2)}>
                    <input
                      className={cn(styles.dayBox14)}
                      type="radio"
                      id="radio"
                      name="view"
                      value="viewButton"
                      onChange={() => setTypeModeAndFetchRecord("Day")}
                      checked={typeMode === "Day"}
                    />
                    <label for="Day">Day</label>
                    <br></br>
                  </div>
                  {/* </div> */}
                </div>
                <div
                  className={cn(
                    styles.flex3_item1,
                    typeMode !== "Day" && styles.reportOpacitylow
                  )}
                >
                  <div className={cn(styles.box12, styles.box12_layout)}>
                    <DatePicker
                      placeholderText={"placeholderText"}
                      selected={selectDate}
                      onChange={(date) => setDateAndFetchRecords(date, "Day")}
                      defaultView="year"
                      disabled={typeMode !== "Day"}
                      maxDate={maxDate}
                      minDate={minDate}
                      customInput={
                        <div className={cn(styles.dayBox15)}>
                          {/* <Calendar name={'asfdasgha'} className={cn(styles.calenderBox)} dateCallback={selectDate} /> */}
                          {typeMode === "Day"
                            ? moment(selectDate).format("YYYY-MM-DD")
                            : "Select Day"}
                          <img
                            src={require("assets/calendar.svg").default}
                            alt="calendar"
                            className={cn(styles.calenderBox)}
                          />
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={cn(styles.block9_spacer1)} />
          <div className={cn(styles.block9_item2)}>
            <div className={cn(styles.block10, styles.block10_layout)}>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <div className={cn(styles.flex3_item)}>
                  <div className={cn(styles.subtitle, styles.subtitle_layout2)}>
                    <input
                      className={cn(styles.monthBox14)}
                      type="radio"
                      id="radio"
                      name="view"
                      value="viewButton"
                      onChange={() => setTypeModeAndFetchRecord("Month")}
                      checked={typeMode === "Month"}
                    />
                    <label for="month">Month</label>
                    <br></br>
                  </div>
                  {/* </div> */}
                </div>
                <div
                  className={cn(
                    styles.flex3_item2,
                    typeMode !== "Month" && styles.reportOpacitylow
                  )}
                >
                  <div className={cn(styles.box12, styles.box12_layout)}>
                    <DatePicker
                      selected={selectMonthYear}
                      // onChange={(date) => setSelectMonthYear(date)}
                      onChange={(date) => setDateAndFetchRecords(date, "Month")}
                      dateFormat="MM/yyyy"
                      showMonthYearPicker
                      showFullMonthYearPicker
                      maxDate={maxDate}
                      minDate={minDate}
                      disabled={typeMode !== "Month"}
                      customInput={
                        <div className={cn(styles.dayBox15)}>
                          {typeMode === "Month"
                            ? moment(selectMonthYear).format("YYYY-MM")
                            : "Select Month"}

                          {
                            <img
                              src={require("assets/calendar.svg").default}
                              alt="calendar"
                              className={cn(styles.calenderBox2)}
                            />
                          }
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={cn(styles.block9_spacer2)} />
          <div className={cn(styles.block9_item3)}>
            <div className={cn(styles.block10, styles.block10_layout)}>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <div className={cn(styles.flex3_item)}>
                  <div className={cn(styles.subtitle, styles.subtitle_layout2)}>
                    <input
                      className={cn(styles.dayBox14)}
                      type="radio"
                      id="radio"
                      name="view"
                      value="viewButton"
                      onChange={() => setTypeModeAndFetchRecord("Year")}
                      checked={typeMode === "Year"}
                    />
                    <label for="year">Year</label>
                    <br></br>
                  </div>
                  {/* </div> */}
                </div>
                <div
                  className={cn(
                    styles.flex3_item3,
                    typeMode !== "Year" && styles.reportOpacitylow
                  )}
                >
                  <div className={cn(styles.box12, styles.box12_layout)}>
                    <DatePicker
                      selected={selectYear}
                      // onChange={(date) => setSelectYear(date)}
                      onChange={(date) => setDateAndFetchRecords(date, "Year")}
                      showYearPicker
                      dateFormat="yyyy"
                      maxDate={maxDate}
                      minDate={minDate}
                      yearItemNumber={10}
                      disabled={typeMode !== "Year"}
                      customInput={
                        <div className={cn(styles.dayBox15)}>
                          {typeMode === "Year"
                            ? moment(selectYear).format("YYYY")
                            : "Select Year"}
                          {
                            <img
                              src={require("assets/calendar.svg").default}
                              alt="calendar"
                              className={cn(styles.calenderBox)}
                            />
                          }
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={cn(styles.block9_spacer3)} />
          <div className={cn(styles.block9_item4)}>
            <div className={cn(styles.subtitle, styles.subtitle_layout2)}>
              <input
                className={cn(styles.dayBox14)}
                type="radio"
                id="radio"
                name="view"
                value="lifetimeButton"
                // onChange={() => setTypeMode("lifeTime")}
                onChange={() => setTypeModeAndFetchRecord("lifeTime")}
                checked={typeMode === "lifeTime"}
              />
              <label for="Lifetime">Lifetime</label>
              <br></br>
            </div>
          </div>
        </div>

        {/* <div className={cn(styles.block7, styles.block7_layout)}>
          <div className={cn(styles.block7_spacer)} />
          <div className={cn(styles.block7_item)}>
            <div className={cn(styles.block8, styles.block8_layout)}>
              <div className={cn(styles.block8_item)}>
                <div className={cn(styles.box10, styles.box10_layout)} />
              </div>
              <div className={cn(styles.block8_spacer)} />
              <h5 className={cn(styles.highlights2, styles.highlights2_layout)}>
                {"Peak Hour"}
              </h5>
            </div>
          </div> */}
        {/* <div className={cn(styles.block7_spacer1)} />
          <div className={cn(styles.block7_item)}>
            <div className={cn(styles.block8, styles.block8_layout)}>
              <div className={cn(styles.block8_item)}>
                <div className={cn(styles.box11, styles.box11_layout)} />
              </div>
              <div className={cn(styles.block8_spacer)} />
              <h5 className={cn(styles.highlights2, styles.highlights2_layout)}>
                {"Partial Peak Hour"}
              </h5>
            </div>
          </div> */}
        {/* <div className={cn(styles.block7_spacer2)} />
          <div className={cn(styles.block7_item)}>
            <div className={cn(styles.block8, styles.block8_layout)}>
              <div className={cn(styles.block8_item)}>
                <div className={cn(styles.box11_2, styles.box11_2_layout)} />
              </div>
              <div className={cn(styles.block8_spacer)} />
              <h5 className={cn(styles.highlights2, styles.highlights2_layout)}>
                {"Off Peak Hour"}
              </h5>
            </div>
          </div>
        </div> */}

        <div className={cn(styles.group, styles.group_layout1)}>
          <div className={cn(styles.block4, styles.block4_layout)}>
            <div className={cn(styles.block4_item)}>
              <div className={cn(styles.box3, styles.box3_layout)}>
                <ChargerTable
                  styles={{ width: "100%", overflowY: "scroll" }}
                  className={cn(styles.flex10, styles.flex10_layout)}
                  data={evseArray}
                  filterdatas={selectedSiteList}
                  getSelectEvseIds={getSelectEvseIds}
                ></ChargerTable>
              </div>
            </div>
            <div className={cn(styles.block4_item1)}>
              <div className={cn(styles.box4, styles.box4_layout)}>
                <ReportTab
                  energyUp={energyUp}
                  energyDown={energyDown}
                  xAxisName={xAxisName}
                />
              </div>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </div>
    </div>
  );
}

Report.inStorybook = true;
